import { render, staticRenderFns } from "./H2V.vue?vue&type=template&id=2438e6b6&scoped=true"
import script from "./H2V.vue?vue&type=script&lang=js"
export * from "./H2V.vue?vue&type=script&lang=js"
import style0 from "./H2V.vue?vue&type=style&index=0&id=2438e6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438e6b6",
  null
  
)

export default component.exports